import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficePromptExperimentOptionsResponseDataSchema,
  BackofficePromptExperimentRunsResponseDataSchema,
  DataResponse,
  LaunchBackofficePromptExperimentSchema,
} from "schema"
import { z } from "zod"

type OptionsResponse = DataResponse<
  z.infer<typeof BackofficePromptExperimentOptionsResponseDataSchema>
>
type RunsResponse = DataResponse<z.infer<typeof BackofficePromptExperimentRunsResponseDataSchema>>

const getBackofficePromptExperimentRunsQueryKey = () => ["backofficePromptExperimentRuns"]

export const getBackofficePromptExperimentOptionsQuery = () =>
  queryOptions({
    queryKey: ["backofficePromptExperimentOptions"],
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<OptionsResponse>("/backoffice/experiments/prompt-options", {
        signal,
      })
      return data.data
    },
  })

export const getBackofficePromptExperimentRunsQuery = () =>
  queryOptions({
    queryKey: getBackofficePromptExperimentRunsQueryKey(),
    refetchInterval: 5000,
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<RunsResponse>("/backoffice/experiments/prompt-runs", {
        params: { limit: 20 },
        signal,
      })
      return data.data
    },
  })

export function useLaunchBackofficePromptExperimentMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: z.input<typeof LaunchBackofficePromptExperimentSchema>) => {
      const { data } = await axios.post<RunsResponse>("/backoffice/experiments/prompt-runs", body)
      return data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getBackofficePromptExperimentRunsQueryKey() })
    },
  })
}
